module.exports = __webpack_public_path__ + "img/utilityvalve_driving.0880db5f.svg";